
import { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { Container } from "react-bootstrap";
import Countdown from 'react-countdown';

import CONSTANTS from "../utils/constants";
import checkCircle from "../assets/img/success-error-pages/check_circle.svg"
import { UUIDContext } from "../UUIDContexted";
import "./Success.css";
import { CountdownProps } from "../interfaces/SuccessProps";

export default function SuccessPage() {
  const PBLData = useContext(UUIDContext);

  const navigateToShop = () => {
    if (PBLData?.returnUrl) {
      window.location.href = PBLData.returnUrl;
    }
  }

  const countDownRenderer = ({ seconds, completed }: CountdownProps) => {
    if (completed && PBLData && PBLData.returnUrl) {
      // Render a completed state
      window.location.href = PBLData.returnUrl;

    } else {
      // Render a countdown
      return <span>{seconds}</span>;
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center">
      <div className="d-flex flex-column align-items-center text-center">
        <div>
          <img src={checkCircle} className="check-circle" alt="Check Circle" data-testid="successPage-check-circle" />
        </div>
        <div className="text-center success-msg">
          <h1 className="message-payment mb-0" data-testid="successPage-paymentSuccessful-message">
            <FormattedMessage id={CONSTANTS.SUCCESS_PAGE.DISPLAY_MESSAGE.PAYMENT_SUCCESSFUL} defaultMessage="PAYMENT SUCCESSFUL!" />
          </h1>
          <h1 className="message-thankyou mb-0" data-testid="successPage-thankYou-message">
            <FormattedMessage id={CONSTANTS.SUCCESS_PAGE.DISPLAY_MESSAGE.THANK_YOU_MESSAGE} defaultMessage="THANK YOU FOR YOUR ORDER" />
          </h1>
          <p className="message-transaction mb-0" data-testid="successPage-transaction-message">
            <FormattedMessage id={CONSTANTS.SUCCESS_PAGE.DISPLAY_MESSAGE.TRANSACTION_COMPLETED} defaultMessage="Your transaction has been completed successfully." />
          </p>
          <p className="message-email mb-0" data-testid="successPage-emailSent-message">
            <FormattedMessage id={CONSTANTS.SUCCESS_PAGE.DISPLAY_MESSAGE.EMAIL_SENT} defaultMessage="We have emailed you details of your order." />
          </p>

          {PBLData && PBLData.returnUrl && PBLData.returnUrl !== "" && PBLData.autoRedirection.toLowerCase() === "true" ?
            <p className="message-autoRedirect mb-0 mt-2" data-testid="successPage-autoRedirect-message">
              <FormattedMessage id={CONSTANTS.SUCCESS_PAGE.DISPLAY_MESSAGE.REDIRECT_MSG_PART1} defaultMessage="You will be redirected to the shop in" />
              &nbsp;
              <Countdown
                date={Date.now() + 5000}
                renderer={countDownRenderer}
              />
              &nbsp;
              <FormattedMessage id={CONSTANTS.SUCCESS_PAGE.DISPLAY_MESSAGE.REDIRECT_MSG_PART2} defaultMessage="seconds or you can click on the Back to the shop button." />
            </p>
            : null
          }

          {PBLData && PBLData.returnUrl && PBLData.returnUrl !== "" ?
            <button
              className="btn btn-primary text-white px-4 rounded-4 back-to-shop-btn mt-3"
              onClick={navigateToShop}
              data-testid="pm-back-to-shop-btn"
            >
              <FormattedMessage
                id={CONSTANTS.BUTTON.BACK_TO_THE_SHOP}
                defaultMessage="Back to the shop"
              />
            </button>
            : null
          }
        </div>
      </div>
    </Container>
  )
}